import { first } from 'lodash';
import { common } from '@gosupersimple/types';

import { Field } from '../types';
import { Select } from '../../components/form/select';
import { createFieldOption } from '../components/select-options/field';
import { SearchInput } from '../../components/form/search-input';
import { createDefaultSorting } from '../utils/slicing';

interface SortingEditorProps {
  fields: Field[];
  sorting: common.Sorting[];
  setSorting(sort: common.Sorting[]): void;
}

export const SortingEditor = (props: SortingEditorProps) => {
  const { fields, sorting, setSorting } = props;

  const sortItem = first(sorting) ?? createDefaultSorting(fields);

  return (
    <>
      <SearchInput
        options={fields.map(createFieldOption)}
        value={sortItem.key}
        onChange={(key) =>
          setSorting([
            {
              ...sortItem,
              key,
            },
          ])
        }
      />
      <div style={{ width: '50%' }}>
        <Select
          options={[
            { label: 'Asc', value: 'ASC' },
            { label: 'Desc', value: 'DESC' },
          ]}
          value={sortItem.direction}
          onChange={(value) =>
            setSorting([
              {
                ...sortItem,
                direction: value as common.Sorting['direction'],
              },
            ])
          }
        />
      </div>
    </>
  );
};
